<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
========================================================================================== -->


<template functional>
    <div class="site-wrapper-reveal relative mb-32">
        <!--===========  Conact us Section Start =========-->
        <div class="contact-us-section-wrappaer processing-contact-us-bg sm:py-32 py-16">
            <div class="container">
                <div class="vx-row items-center">
                    <div class="vx-col lg:w-1/2 w-full">
                        <div class="conact-us-wrap-one">
                            <h3 class="heading text-white">Let’s Talk About Your Property Management Needs</h3>
                        </div>
                    </div>

                    <div class="vx-col lg:w-1/2 w-full">
                        
                        <div class="contact-info sytle-one service-contact text-left">
                            <div class="contact-list-item">
                                <a href="tel:3144745277" class="single-contact-list">
                                    <div class="content-wrap">
                                        <div class="content">
                                            <div class="icon">
                                                <feather-icon icon="PhoneIcon" svgClasses="h-12 w-12" class="" />
                                            </div>
                                            <div class="main-content">
                                                <h6 class="heading">Call Us Today</h6>
                                                <div class="text">(314) 474-5277</div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                                <a href="mailto:info@axisrealtygroup.org" class="single-contact-list">
                                    <div class="content-wrap">
                                        <div class="content">
                                            <div class="icon">
                                                <feather-icon icon="MailIcon" svgClasses="h-12 w-12" class="" />
                                            </div>
                                            <div class="main-content">
                                                <h6 class="heading">Email Us</h6>
                                                <div class="text">info@axisrealtygroup.org</div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                                <div class="contact-us-button mt-12">
                                    <router-link to="./contact-us" class="vs-component vs-button vs-button-warning text-white vs-button-filled">Contact us</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--========== Conact us Section End =========-->

        <footer class="footer-area-wrapper bg-gray" :class="classes">
            <div class="footer-copyright-area py-10">
                <div class="container">
                    <div class="vx-row items-center">
                        <div class="vx-col sm:w-1/2 w-full text-center sm:text-left">
                            <span class="copyright-text">&copy; {{ new Date().getFullYear() }} Axis Realty Group LLC. <a href="#">All Rights Reserved.</a></span>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full text-center sm:text-right">
                            <ul class="list ht-social-networks solid-rounded-icon">
                                <li class="item">
                                    <a href="https://twitter.com" target="_blank" aria-label="Twitter" class="social-link hint--bounce hint--top hint--primary">
                                        <feather-icon icon="TwitterIcon" svgClasses="h-5 w-5" class="link-icon" />
                                    </a>
                                </li>
                                <li class="item">
                                    <a href="https://facebook.com" target="_blank" aria-label="Facebook" class="social-link hint--bounce hint--top hint--primary">
                                        <feather-icon icon="FacebookIcon" svgClasses="h-5 w-5" class="link-icon" />
                                    </a>
                                </li>
                                <li class="item">
                                    <a href="https://instagram.com" target="_blank" aria-label="Instagram" class="social-link hint--bounce hint--top hint--primary">
                                        <feather-icon icon="InstagramIcon" svgClasses="h-5 w-5" class="link-icon" />
                                    </a>
                                </li>
                                <li class="item">
                                    <a href="https://linkedin.com" target="_blank" aria-label="Linkedin" class="social-link hint--bounce hint--top hint--primary">
                                        <feather-icon icon="LinkedinIcon" svgClasses="h-5 w-5" class="link-icon" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        
    </div>
</template>

<script>
export default {
  name: 'the-footer',
  data () {
    return {
    }
  },  
  computed: {
  },
  methods: {
  },
  props: {
    classes: {
      type: String
    }
  }
}
</script>
